import MobileTab from './MobileTab';
import MobileTabItem from './MobileTabItem';
import MobileTabSessionDropdown from './MobileTabSessionDropdown';

export const components = {
  MobileTab,
  MobileTabItem,
  MobileTabSessionDropdown,
};
